import React from 'react';
import { strings } from 'strings';

import { GameEventForm } from '../../components/GameEventForm';

const CreateGameEventScreen = () => {
  return <GameEventForm title={strings.gameEvent.create.title} />;
};

export default CreateGameEventScreen;
